module.exports = __webpack_public_path__ + "static/media/XL.b32a4d68.jpg";